import {Button, Col, Row} from "react-bootstrap";
import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import {toast} from "react-toastify";
import {
  TYPE_KE_HOACH_DAO_TAO
} from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/constants/constansKeHoach";
import TableNhanLuc from "./TableNhanLuc";
import LabelRequired from "../../../../component/LabelRequired";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import TextField from "../../../../component/TextField";
import {getListTrangTB} from "../services/services";
import {MAX_PAGE_SIZE} from "../../../../utils/Constant";

interface Props {
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>;
  dataTrangThietBi: any[];
  setDataTrangThietBi: Dispatch<SetStateAction<any[]>>;
  isView?: boolean;
}

const YCTrangThietBi = (props: Props) => {
  const {dataTrangThietBi, setDataTrangThietBi, isView} = props;

  const [selectedTrangThietBi, setSelectedTrangThietBi] = useState<any>(null);
  const [technicalRequirement, setTechnicalRequirement] = useState<any>(null);
  const [note, setNote] = useState<string>('');
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  const [dsTrangThietBi, setDsTrangThietBi] = useState<any>([
  ]);

  const getListDataTrangTB = async () => {
    try {
      const data = await getListTrangTB({pageSize: MAX_PAGE_SIZE})
      setDsTrangThietBi(data?.data?.data?.content ?? [])
    } catch (e) {

    }
  }

  useEffect(() => {
    getListDataTrangTB()
  }, [])

  const handleAddOrUpdate = () => {
    if (!selectedTrangThietBi || !technicalRequirement) {
      toast.warning('Vui lòng chọn đầy đủ trang thiết bị và yêu cầu kỹ thuật');
      return;
    }

    const newItem = {
      equipment: selectedTrangThietBi.id,
      equipmentName: selectedTrangThietBi.name,
      note,
      technicalRequirement: technicalRequirement
    };

    if (editingIndex !== null) {
      const updatedList = [...dataTrangThietBi];
      updatedList[editingIndex] = newItem;
      setDataTrangThietBi(updatedList);
      setEditingIndex(null);
      toast.success('Cập nhật thành công');
    } else {
      setDataTrangThietBi([newItem, ...dataTrangThietBi]);
      toast.success('Thêm thành công');
    }

    setSelectedTrangThietBi(null);
    setTechnicalRequirement('');
    setNote('');
  };

  const handleEdit = (row: any, index: number) => {
    setSelectedTrangThietBi({id: row?.equipment, name: row?.equipmentName});
    setTechnicalRequirement(row.technicalRequirement);
    setNote(row.note || '');
    setEditingIndex(index);
  };

  const handleDelete = (index: number) => {
    const updatedList = dataTrangThietBi.filter((_: any, i: number) => i !== index);
    setDataTrangThietBi(updatedList);
    toast.success('Xóa thành công');
  };

  const columnsDkDaoTao = [
    {
      name: "STT",
      field: "",
      headerStyle: {width: 80},
      cellStyle: {textAlign: "center"},
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView
      ? [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {width: 100},
          cellStyle: {textAlign: "center", justifyContent: "center"},
          render: (row: any, index: number) => (
            <div className="d-flex justify-content-center">
              <i
                onClick={() => handleEdit(row, index)}
                className="bi bi-pencil-square text-navy cursor-pointer"
                style={{cursor: 'pointer', marginRight: '10px'}}
              ></i>
              <i
                onClick={() => handleDelete(index)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{cursor: 'pointer'}}
              ></i>
            </div>
          ),
        },
      ]
      : []),
    {
      name: "Trang thiết bị",
      field: "equipmentName",
      headerStyle: {minWidth: 120},
      cellStyle: {textAlign: "left"},
      render: (row: any) => row.equipmentName || row.item?.equipmentName || '',
    },
    {
      name: "Yêu cầu kỹ thuật",
      field: "technicalRequirement",
      headerStyle: {minWidth: 200},
      cellStyle: {textAlign: "left"},
      render: (row: any) => row.technicalRequirement || row.item?.technicalRequirement || '',
    },
    {
      name: "Ghi chú",
      field: "note",
      headerStyle: {minWidth: 120},
      cellStyle: {textAlign: "left"},
      render: (row: any) => row.note || row.item?.note || '',
    },
  ];

  return (
    <div className="">
      <div className="spaces  mt-2 title">
        <span className="text-title fw-bold fs-5 spaces mb-5 mt-20">
          Trang thiết bị
        </span>
      </div>
      <Row>
        <Col lg={1} className="spaces">
          <div className="spaces pt-10 min-w-135">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Trang thiết bị"/>
            </div>
          </div>
        </Col>
        <Col lg={5} className="spaces pl-36">
          <div className="d-flex">
            <AutocompleteObjectV2
              options={dsTrangThietBi}
              value={selectedTrangThietBi}
              isSearchDefauilt={true}
              name="WmsCode"
              onChange={(options: any) => setSelectedTrangThietBi(options)}
              className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
              isClearable={true}
              disabled={isView}
            />
          </div>
        </Col>
        <Col lg={1} className="spaces">
          <div className="spaces pt-10 min-w-135">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Yêu cầu kỹ thuật"/>
            </div>
          </div>
        </Col>
        <Col lg={5} className="spaces pt-8 pl-36">
          <TextField
            name="technicalRequirement"
            type="text"
            onChange={(e: any) => setTechnicalRequirement(e.target.value)}
            value={technicalRequirement}
            disabled={isView}
          />
        </Col>
        <Col lg={1} className="spaces">
          <div className="spaces pt-10 min-w-135">
            <div className="spaces mt-1">
              <LabelRequired className="min-w-100px" label="Ghi chú"/>
            </div>
          </div>
        </Col>
        <Col lg={11} className="spaces pt-8 pl-36">
          <TextField
            name="note"
            type="text"
            onChange={(e: any) => setNote(e.target.value)}
            value={note}
            disabled={isView}
          />
        </Col>
      </Row>
      {!isView && (
        <div className="flex mt-10 spaces items-center">
          <Button
            className="btn-fill spaces min-w-90px btn btn-primary"
            onClick={handleAddOrUpdate}
            type="button"
          >
            <i className="bi bi-plus-lg text-pri fs-3"></i>
            {editingIndex !== null ? 'Cập nhật' : 'Thêm'}
          </Button>
          {editingIndex !== null && (
            <Button
              className="btn-fill spaces min-w-90px btn btn-secondary ml-2"
              onClick={() => {
                setEditingIndex(null);
                setSelectedTrangThietBi(null);
                setTechnicalRequirement(null);
                setNote('');
              }}
              type="button"
            >
              Hủy
            </Button>
          )}
        </div>
      )}
      <TableNhanLuc
        columns={columnsDkDaoTao}
        isView={isView}
        dsItems={dataTrangThietBi ?? []}
      />
    </div>
  );
};

export default YCTrangThietBi;